import React from 'react';
import { Modal } from 'rsuite';
import styled from 'styled-components';

const StyledModalBody = styled.div`
    padding: 12px;
`;

const ScheduleTypesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 8px;
    margin-top: 8px;
`;

const ScheduleTypeButton = styled.button`
    text-align: left;
    padding: 8px;
    border: 2px solid #ddd;
    border-radius: 4px;
    background-color: white;
    cursor: pointer;
    transition: all 0.2s;
    width: 100%;
    
    &:hover {
        border-color: #2196f3;
        background-color: #e3f2fd;
        transform: translateY(-2px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

const TypeColorDot = styled.span`
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${props => props.color};
    border: 1px solid rgba(0,0,0,0.1);
    flex-shrink: 0;
    display: inline-block;
`;

const AddScheduleModal = ({
    open,
    onClose,
    selectedDate,
    scheduleTypes,
    onTypeSelect,
    loading
}) => {
    const formatDate = (date) => {
        if (!date) return '';
        const dateObj = date instanceof Date ? date : new Date(date);
        if (isNaN(dateObj.getTime())) return '';
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}年${month}月${day}日`;
    };

    return (
        <Modal open={open} onClose={onClose} size="lg">
            <Modal.Header>
                <Modal.Title>新增排班 - {formatDate(selectedDate)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <StyledModalBody>
                <div className="form-group">
                    <label>選擇班別：</label>
                    <ScheduleTypesGrid>
                        {scheduleTypes
                            .filter((type) => {
                                // 過濾掉例假日
                                const dayType = type.day_type || 'normal';
                                return dayType !== 'regular_holiday';
                            })
                            .map((type) => {
                                const dayType = type.day_type || 'normal';
                                let dayTypeLabel = '';
                                // 根據日期類型決定顏色
                                let typeColor = type.color;
                                if (dayType === 'rest_day') {
                                    dayTypeLabel = ' (休息日)';
                                    typeColor = '#ff9800'; // 休息日：橙色
                                } else if (dayType === 'regular_holiday') {
                                    dayTypeLabel = ' (例假日)';
                                    typeColor = '#f44336'; // 例假日：紅色
                                }
                                
                                return (
                                    <ScheduleTypeButton
                                        key={type.id}
                                        type="button"
                                        onClick={() => onTypeSelect(type.id)}
                                        disabled={loading}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <TypeColorDot color={typeColor} />
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: 'bold', fontSize: '13px' }}>{type.name}</div>
                                                {dayTypeLabel && (
                                                    <div style={{ fontSize: '10px', color: '#666', marginTop: '2px' }}>
                                                        {dayTypeLabel.replace(/[()]/g, '')}
                                                    </div>
                                                )}
                                                {type.time_range && (
                                                    <div style={{ fontSize: '10px', color: '#999', marginTop: '2px' }}>
                                                        {type.time_range}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </ScheduleTypeButton>
                                );
                            })}
                    </ScheduleTypesGrid>
                </div>
                </StyledModalBody>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" onClick={onClose} style={{
                    padding: '8px 16px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    cursor: 'pointer'
                }}>
                    取消
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddScheduleModal;
